import { useCallback } from 'react';
import { useToastContext } from '../components/ui/ToastProvider';

export const useToast = () => {
  const { showToast } = useToastContext();

  const showSuccess = useCallback(
    (message: string) => showToast({ message, severity: 'success' }),
    [showToast],
  );
  const showError = useCallback(
    (message: string) => showToast({ message, severity: 'error' }),
    [showToast],
  );
  const showWarning = useCallback(
    (message: string) => showToast({ message, severity: 'warning' }),
    [showToast],
  );
  const showInfo = useCallback(
    (message: string) => showToast({ message, severity: 'info' }),
    [showToast],
  );

  return {
    showToast,
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };
};
